import './ccf-edit-pen-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfEditPenIconProps extends SvgIconProps {}

/**
 * CcfEditPenIcon used to disply edit pen icon in the contact card history panel
 * @param props - CcfEditPenIconProps
 * @example -- <CcfEditPenIcon />
 */
export function CcfEditPenIcon(props: CcfEditPenIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="edit_pencil" clipPath="url(#clip-edit_pencil)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(6 6)">
          <path id="Path_14079" data-name="Path 14079" d="M11.809,2.265,9.82.171a.5.5,0,0,0-.75,0L.563,8.242a.237.237,0,0,0-.074.153L0,11.25a.248.248,0,0,0,.065.208.24.24,0,0,0,.171.076.2.2,0,0,0,.035,0L3.136,11.2a.244.244,0,0,0,.17-.069l8.468-8.042a.508.508,0,0,0,.034-.819ZM2.768,10.16l-1.523.179L1.5,8.828,9.382,1.35l1.264,1.331Z" transform="translate(0 0)" fill="#707070"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfEditPenIcon;
